import 'pblog'
console.log('Hello World from Webpacker pblog pack')